import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
import { isFromZeConsumption } from './helper/utils';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';

export default {
  key: planTypes[planTypes.EVENT_SAAS],
  data() {
    return {
      logo: getPlanLogo(planTypes.EVENT_SAAS),
      title: `${this.$t('billing.planform.title.zoom_events')}${isFromZeConsumption() ? ' ' + this.$t('billing.events.ppa.title') : ''}`,
      subtitle: '',
      capacityKey: 'capacity',
      planType: planTypes.EVENT_SAAS,
      description: this.$t('billing.events.eventSaas.addon_desc'),
      totalLimitDesc: "",
      configDescription: this.$t('billing.events.eventSaas.desc'),
    };
  },
  computed: {
    trackingPlanKey() {
      return getTrackingProductNameByPlanType(this.planType);
    },
  }
};
